/**
 * Frontend canonical-unit helper — mirrors backend `units.py` rules.
 * Used to (a) preview canonical conversions in the UI and
 * (b) reject unsupported units before save.
 */

const TABLE = {
  // mass → gm
  kg: { canonical: 'gm', factor: 1000 },
  kgs: { canonical: 'gm', factor: 1000 },
  kilogram: { canonical: 'gm', factor: 1000 },
  kilograms: { canonical: 'gm', factor: 1000 },
  g: { canonical: 'gm', factor: 1 },
  gm: { canonical: 'gm', factor: 1 },
  gms: { canonical: 'gm', factor: 1 },
  gram: { canonical: 'gm', factor: 1 },
  grams: { canonical: 'gm', factor: 1 },

  // volume → ml
  l: { canonical: 'ml', factor: 1000 },
  ltr: { canonical: 'ml', factor: 1000 },
  lt: { canonical: 'ml', factor: 1000 },
  litre: { canonical: 'ml', factor: 1000 },
  liter: { canonical: 'ml', factor: 1000 },
  litres: { canonical: 'ml', factor: 1000 },
  liters: { canonical: 'ml', factor: 1000 },
  ml: { canonical: 'ml', factor: 1 },
  millilitre: { canonical: 'ml', factor: 1 },
  milliliter: { canonical: 'ml', factor: 1 },

  // count → pcs
  pcs: { canonical: 'pcs', factor: 1 },
  pc: { canonical: 'pcs', factor: 1 },
  nos: { canonical: 'pcs', factor: 1 },
  no: { canonical: 'pcs', factor: 1 },
  each: { canonical: 'pcs', factor: 1 },
  ea: { canonical: 'pcs', factor: 1 },
  piece: { canonical: 'pcs', factor: 1 },
  pieces: { canonical: 'pcs', factor: 1 },
  unit: { canonical: 'pcs', factor: 1 },
  units: { canonical: 'pcs', factor: 1 },
  bottle: { canonical: 'pcs', factor: 1 },
  bottles: { canonical: 'pcs', factor: 1 },
  packet: { canonical: 'pcs', factor: 1 },
  packets: { canonical: 'pcs', factor: 1 },
  egg: { canonical: 'pcs', factor: 1 },
  eggs: { canonical: 'pcs', factor: 1 },
  jar: { canonical: 'pcs', factor: 1 },
  jars: { canonical: 'pcs', factor: 1 },
  box: { canonical: 'pcs', factor: 1 },
  boxes: { canonical: 'pcs', factor: 1 },
  can: { canonical: 'pcs', factor: 1 },
  cans: { canonical: 'pcs', factor: 1 },
  pack: { canonical: 'pcs', factor: 1 },
  packs: { canonical: 'pcs', factor: 1 },
};

export function normalizeUnitKey(u) {
  return (u || '').toString().trim().toLowerCase();
}

export function toCanonical(qty, unit) {
  const key = normalizeUnitKey(unit);
  const info = TABLE[key];
  if (!info) {
    return { qty, base_unit: unit, conversion_failed: true, reason: key ? `unknown_unit:${key}` : 'empty_unit' };
  }
  const newQty = (Number(qty) || 0) * info.factor;
  return { qty: newQty, base_unit: info.canonical, conversion_failed: false, factor: info.factor };
}

export function isSameClass(unit1, unit2) {
  const a = TABLE[normalizeUnitKey(unit1)];
  const b = TABLE[normalizeUnitKey(unit2)];
  if (!a || !b) return false;
  return a.canonical === b.canonical;
}

export const CANONICAL_BASES = ['gm', 'ml', 'pcs'];
export const ACCEPTED_UNITS_FOR_UI = ['gm', 'kg', 'ml', 'l', 'pcs'];
